import * as bus from "@sinch/bus";
import { loadCrashPage } from "./loadCrashPage";

const unsub = bus.listen((message) => {
  if (bus.isData(message)) {
    const { name, message: errorMessage, stack } = message.payload;
    const err = new Error(errorMessage);
    err.name = name;
    err.stack = stack || "";
    loadCrashPage(err);
  }
}, bus.isCrashEvent);

window.addEventListener("unload", unsub);
